import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Form from '../ui/Form';
import DeleteConfirmation from '../ui/DeleteConfirmation';
import { sortOpts, getChanges } from '../../utils/utils';

class TodosItem extends Form {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      editing: false,
      delConf: false,
      errors: {}
    }
  }

  editTodo = e => {
    const oldD = this.props.data;
    const { data } = this.state;
    const toSend = getChanges(data, oldD);
    if(!Object.keys(toSend).length) {
      this.cancelEditing();
    }
    else {
      toSend.todo_id = data.todo_id;
      this.props.editTodo(toSend, errors => {
        if(errors){
          this.setState({errors});
          return;
        }
        this.setState({editing: false, errors: {}});
      });
    }
  }

  updateCheckbox = e => {
    e.preventDefault();
    e.stopPropagation();
    const val = this.props.data.todo_done ? 0 : 1;
    this.props.editTodo({
      todo_id: this.props.data.todo_id,
      todo_done: val
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({errors: {}});
    });
  }

  deleteTodo = e => {
    e.preventDefault();
    e.stopPropagation();
    this.props.editTodo({
      ...this.props.data,
      todo_active: 0
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({errors: {}});
    });
  }

  updateDate = e => {
    this.setState({
      data: {
        ...this.state.data,
        todo_dline: e.format('Y-MM-DD')
      }
    });
  }

  render() {
    const { data, users } = this.props;
    const { data: nData } = this.state;
    const { errors, delConf } = this.state;
    const user = users.find(el => el.user_id === data.todo_user_id);
    const userName = user ? (user.user_fname + ' ' + user.user_lname) : '';
    var usersOpt = [];
    for (let key in users){
      if(users.hasOwnProperty(key)) {
        if(users[key].user_active || users[key].user_id === data.todo_user_id){
          usersOpt.push({
            value: users[key].user_id,
            label: users[key].user_fname + " " + users[key].user_lname
          });
        }
      }
    }
    usersOpt.sort(sortOpts);
    return this.state.editing ? (
      <div className="row todo-item">
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        <div className="col-xs-6">
          <div className="form-inline">
            <div className="todo-text-edit">
              <input
                type="text"
                value={nData.todo_desc}
                onChange={this.updateInput}
                name="todo_desc"
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="col-xs-1">
          {!!user && (
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(nData.todo_dline)}
              onChange={this.updateDate}
            />
          )}
        </div>
        <div className="col-xs-2">
          {!!user && (
            <Select
              className="col-sm-12"
              clearable={false}
              options={usersOpt}
              value={nData.todo_user_id}
              onChange={e => this.updateSelect(e,'todo_user_id')}
            />
          )}
        </div>
        <div className="col-xs-3">
          <button
            onClick={this.editTodo}
            className="btn btn-success btn-sm"
          >
            <span className="glyphicon glyphicon-save" />
          </button>{" "}
          <button
            onClick={this.cancelEditing}
            className="btn btn-default btn-sm"
          >
            <span className="glyphicon glyphicon-remove" />
          </button>
        </div>
      </div>
    ) : (
      <div
        className={classnames({
          row: true,
          'todo-item': true,
          'text-danger': user && data.todo_dline <= moment().format('YYYY-MM-DD') && !data.todo_done
        })}
        onClick={this.startEditing}
      >
        {delConf && (
          <DeleteConfirmation
            onDelete={this.deleteTodo}
            onCancel={this.toggleDelConf}
          />
        )}
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        <div className="col-xs-6">
          <div className="form-inline">
            <button
              type="button"
              className={classnames({
                btn: true,
                "btn-sm": true,
                "btn-success": !data.todo_done
              })}
              onClick={this.updateCheckbox}>
              <span
                className={classnames({
                  glyphicon: true,
                  "glyphicon-check": data.todo_done,
                  "glyphicon-unchecked": !data.todo_done
                })}
              ></span>
            </button>
            <span
              className={data.todo_done ? "todo-text-done" : "todo-text"}
            >{data.todo_desc}</span>
          </div>
        </div>
        <div className="col-xs-1">
          {user ? moment(data.todo_dline).format('L') : ''}
        </div>
        <div className="col-xs-2">
          {userName}
        </div>
        <div className="col-xs-3">
          <button
            onClick={this.toggleDelConf}
            className="btn btn-danger btn-sm"
          >
            <span className="glyphicon glyphicon-trash" />
          </button>
        </div>
      </div>
    );
  }
}

export default TodosItem;



// WEBPACK FOOTER //
// ./src/components/todo/TodosItem.js